"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initQuickStyle = exports.usePropsStyle = exports.TextQuery = exports.ButtonQuery = exports.withCQuery = exports.CQuery = exports.useDynamicResponsiveValue = exports.useResponsiveStyle = exports.ResponsiveViewport = exports.Parser = exports.Img = exports.Input = exports.Scroll = exports.Text = exports.Row = exports.Col = exports.Button = void 0;
var globalProps_1 = require("./utils/globalProps");
var Text_1 = __importDefault(require("./components/Text"));
var Button_1 = require("./components/Button");
Object.defineProperty(exports, "Button", { enumerable: true, get: function () { return __importDefault(Button_1).default; } });
var Col_1 = require("./components/Col");
Object.defineProperty(exports, "Col", { enumerable: true, get: function () { return __importDefault(Col_1).default; } });
var Row_1 = require("./components/Row");
Object.defineProperty(exports, "Row", { enumerable: true, get: function () { return __importDefault(Row_1).default; } });
var Text_2 = require("./components/Text");
Object.defineProperty(exports, "Text", { enumerable: true, get: function () { return __importDefault(Text_2).default; } });
var Scroll_1 = require("./components/Scroll");
Object.defineProperty(exports, "Scroll", { enumerable: true, get: function () { return __importDefault(Scroll_1).default; } });
var Input_1 = require("./components/Input");
Object.defineProperty(exports, "Input", { enumerable: true, get: function () { return __importDefault(Input_1).default; } });
var Img_1 = require("./components/Img");
Object.defineProperty(exports, "Img", { enumerable: true, get: function () { return __importDefault(Img_1).default; } });
var ParserReactComponent_1 = require("./utils/parser/ParserReactComponent");
Object.defineProperty(exports, "Parser", { enumerable: true, get: function () { return __importDefault(ParserReactComponent_1).default; } });
var useResponsiveStyle_1 = require("./components/hooks/useResponsiveStyle");
Object.defineProperty(exports, "ResponsiveViewport", { enumerable: true, get: function () { return useResponsiveStyle_1.ResponsiveViewport; } });
Object.defineProperty(exports, "useResponsiveStyle", { enumerable: true, get: function () { return useResponsiveStyle_1.useResponsiveStyle; } });
Object.defineProperty(exports, "useDynamicResponsiveValue", { enumerable: true, get: function () { return useResponsiveStyle_1.useDynamicResponsiveValue; } });
var CQuery_1 = require("./utils/CQuery");
Object.defineProperty(exports, "CQuery", { enumerable: true, get: function () { return __importDefault(CQuery_1).default; } });
Object.defineProperty(exports, "withCQuery", { enumerable: true, get: function () { return CQuery_1.withCQuery; } });
Object.defineProperty(exports, "ButtonQuery", { enumerable: true, get: function () { return CQuery_1.ButtonQuery; } });
Object.defineProperty(exports, "TextQuery", { enumerable: true, get: function () { return CQuery_1.TextQuery; } });
var hooks_1 = require("./components/hooks");
Object.defineProperty(exports, "usePropsStyle", { enumerable: true, get: function () { return hooks_1.usePropsStyle; } });
var setMainColor = function (mainColor) {
    globalProps_1.globalStyleInstance.setMainColor(mainColor);
};
var setAdditionStyles = function (styles) {
    globalProps_1.globalStyleInstance.setAdditionStyles(styles);
};
var setFontStyle = function (fontObject) {
    Text_1.default.setFontStyle(fontObject);
};
var setStyleHooks = function (hooks) {
    globalProps_1.globalStyleInstance.setStyleHooks(hooks);
};
exports.initQuickStyle = {
    setMainColor: setMainColor,
    setAdditionStyles: setAdditionStyles,
    setFontStyle: setFontStyle,
    setStyleHooks: setStyleHooks,
};
//# sourceMappingURL=index.js.map